import api from "./axios";

export const getStockLedger =
()=>
api.get(
  "/stock-ledger"
);